import { createNamespacedHelpers } from 'vuex';
import { DefineActions, DefineGetters, DefineMutations } from 'vuex-type-helper';
import { Getters, Mutations, Actions, Settings, ReviewType } from '@/models/Settings.model';

// Inital state
const state: Settings = {
  reviewTypes: [],
  reviewSettings: [],
};

// Gets the values of our state usually called from components
const getters: DefineGetters<Getters, Settings> = {
  reviewTypes: (state) => state.reviewTypes,
  reviewSettings: (state) => state.reviewSettings,

  logoUrlByReviewTypeId: (state) =>  (reviewTypeId: number): string | undefined => {
    const foundIndex = state.reviewTypes.findIndex((item: ReviewType) => item.id === reviewTypeId);

    if (foundIndex >= 0) {
      return state.reviewTypes[foundIndex].logoUrl;
    } else {
      return undefined;
    }
  },
};

// Sets values or changes to state. Must be called via an action.
const mutations: DefineMutations<Mutations, Settings> = {
  setReviewTypes(state, { reviewTypes }) {
    state.reviewTypes = reviewTypes;
  },

  setReviewSettings(state, { reviewSettings }) {
    state.reviewSettings = reviewSettings;
  },
};

// Async functions that will contain the logic / service calls and commit mutations to state
const actions: DefineActions<Actions, Settings, Mutations, Getters> = {
  setReviewTypes({ commit }, payload) {
    commit('setReviewTypes', payload);
  },

  setReviewSettings({ commit }, payload) {
    commit('setReviewSettings', payload);
  },
};

export const {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} = createNamespacedHelpers<Settings, Getters, Mutations, Actions>('SettingsModule');

export const SettingsModule = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
